import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import { AddSearchFlightFDDispatch } from '../reducers/FDReducer';
import {
	addBusSearchDispatch,
	fetchBusCityDesDispatch,
	fetchSeatLayoutDispatch,
} from '../reducers/BusReducer';
import {
	setSelectedBusArr,
	setSelectedBusDepart,
	setSelectedTripID,
} from '../reducers/UiReducer';
import { Showseat } from '../components/resuableComponents/ShowSeat';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SearchResultBus = () => {
	const { city, loadinghome } = useSelector((state) => state.home);
	const { busSearch, layoutloading, seatLayout, buscity, busDes } = useSelector(
		(state) => state.bus
	);
	const { tripid, busDepart, busArr } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	const [departDate, setDepartDate] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [filterDataD, setFilterDataD] = useState('');
	const [filterData2, setFilterData2] = useState('');
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	function timeConvertbus(a) {
		let arhour = Math.floor(a / 60);
		if (arhour > 24) {
			arhour = arhour - 24;
		}
		let armin = a % 60;
		let format = `${arhour}:${armin === 0 ? '00' : armin}:00`;
		function formatTime(timeString) {
			const [hourString, minute] = timeString.split(':');
			const hour = +hourString % 24;
			return (hour % 12 || 12) + ':' + minute + (hour < 12 ? ' AM' : ' PM');
		}
		return formatTime(format);
		console.log('first', armin);
	}
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const handleChange = (value) => {
		let results = [];
		console.log('value', value.split(',')[1]);
		results =
			buscity &&
			buscity?.result &&
			buscity?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		if (value) {
			dispatch(setSelectedBusDepart(value));
			let formData = {
				source: value.split(',')[1],
			};
			dispatch(fetchBusCityDesDispatch(formData));
		}
		console.log('results', results);
		if (results?.length <= 80) {
			setFilterDataD(results);
		}
	};
	const opsList =
		filterDataD?.length > 0 &&
		filterDataD?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	const handleChange2 = (value) => {
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (value) {
			dispatch(setSelectedBusArr(value));
		}
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const opsList2 =
		filterData2?.length > 0 &&
		filterData2?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	let filterData = [];
	filterData =
		busSearch &&
		busSearch.result &&
		busSearch.result.availableTrips &&
		busSearch.result.availableTrips.length > 0 &&
		busSearch.result.availableTrips.slice().sort((a, b) => {
			let first = Array.isArray(a?.fares) ? a?.fares[0] : a.fares;
			let second = Array.isArray(b?.fares) ? b?.fares[0] : b.fares;
			return first - second;
		});
	console.log('fILTER', filterData);
	const handleSubmit = () => {
		let formData = {
			departure_city: busDepart.split(' ')[0],
			arrival_city: busArr.split(' ')[0],
			sourceid: busDepart.split(',')[1],
			destinationid: busArr.split(',')[1],
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	useEffect(() => {
		dispatch(addBusSearchDispatch(location.state));
		// dispatch(AddSearchFlightFDDispatch(location.state));
	}, [location.state]);
	return (
		<div>
			<Navbar />
			{filterData?.length > 0 ? (
				<>
					<Box style={{ background: '#721053', padding: 20 }}>
						<Container>
							<Grid container spacing={3}>
								<Grid item xs={4}>
									<AutoComplete
										style={{ width: '100%', borderRadius: 1 }}
										dropdownMenuStyle={{
											maxHeight: 1000,
											overflowY: 'visible',
											maxWidth: 500,
										}}
										placeholder='From'
										onChange={handleChange}>
										{opsList}
									</AutoComplete>
								</Grid>
								<Grid item xs={4}>
									<AutoComplete
										style={{ width: '100%', borderRadius: 2 }}
										dropdownMenuStyle={{
											maxHeight: 1000,
											overflowY: 'visible',
											maxWidth: 500,
										}}
										placeholder='From'
										onChange={handleChange2}>
										{opsList2}
									</AutoComplete>
								</Grid>
								<Grid item xs={2}>
									<DatePicker
										onChange={onChange}
										style={{ width: '100%', padding: 8 }}
									/>
								</Grid>{' '}
								<Grid item xs={2}>
									<Button
										onClick={() => handleSubmit()}
										style={{
											background: '#EC5B24',
											color: 'white',
											width: '100%',
											padding: 7,
											height: 'auto',
										}}>
										Search
									</Button>
								</Grid>
							</Grid>
						</Container>
					</Box>
					<Box
						style={{
							background: '#FFF',
							boxShadow: '0 0 10px rgba(0,0,0,.3)',

							paddingTop: 10,
						}}>
						<Container>
							<Grid container spacing={2}>
								<Grid item xs={4}>
									<Box>
										<span>Bus Type</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>AC</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Non-AC</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Seat</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>Sleeper</span>
										</Box>
									</Box>
								</Grid>
								<Grid item xs={8}>
									<Box>
										<span>Timing</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												5AM TO 12PM (Morning)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												12PM TO 5PM (Afternoon)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												5PM TO 10PM (Evening)
											</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>
												10PM TO 5AM (Overnight)
											</span>
										</Box>
									</Box>
								</Grid>
							</Grid>
						</Container>
					</Box>
				</>
			) : (
				''
			)}

			<Container>
				<Box
					style={{
						marginTop: 50,
						marginBottom: 50,
						paddingLeft: 100,
						paddingRight: 100,
					}}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<h2 style={{ fontSize: 20 }}>{`Bus From ${
							location.state.departure_city
						} to ${location.state.arrival_city}(${
							filterData?.length ? filterData?.length : ''
						})`}</h2>
						<h3 style={{ fontSize: 20 }}>{location.state.dateofjourney}</h3>
					</Box>
					<Grid container spacing={4}>
						<Grid item xs={12} lg={12}>
							{filterData?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{filterData?.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Box
													style={{
														// display: 'flex',
														// justifyContent: 'space-between',
														alignItems: 'center',
														borderRadius: 4,
														background: '#fff',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														padding: 30,
														marginTop: 10,
													}}>
													<Grid container alignItems={'center'} spacing={4}>
														<Grid item xs={12} lg={3}>
															<Box>
																<span style={{ fontSize: 18 }}>
																	{item.travels}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{item.busType}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'green',
																		fontSize: 12,
																	}}>
																	Total {item.availableSeats} seats left
																</span>
															</Box>
														</Grid>
														<Grid item xs={12} lg={6}>
															<Box
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																}}>
																<Box>
																	<span
																		style={{
																			fontSize: 14,
																			color: 'rgba(0,0,0,.38)',
																		}}>
																		{location.state.departure_city}
																	</span>
																	<br></br>
																	<span style={{ fontSize: 20 }}>
																		{' '}
																		{timeConvertbus(item.departureTime)}
																	</span>
																</Box>
																<Box textAlign={'center'}>
																	<span
																		style={{
																			fontSize: 14,
																			color: 'rgba(0,0,0,.38)',
																		}}>
																		{item.duration}
																	</span>
																	<br></br>
																	<span>-------------------</span>
																	<br></br>

																	<span>
																		{item.AirlineCode
																			? item.Segments[0].length === 1
																				? 'Non Stop'
																				: item.Segments[0].length === 2
																				? '1 Stop'
																				: item.Segments[0].length === 3
																				? '2 Stop'
																				: ''
																			: ''}
																	</span>
																</Box>
																<Box>
																	<span
																		style={{
																			fontSize: 14,
																			color: 'rgba(0,0,0,.38)',
																		}}>
																		{location.state.arrival_city}
																	</span>
																	<br></br>
																	<span style={{ fontSize: 20 }}>
																		{' '}
																		{timeConvertbus(item.arrivalTime)}
																	</span>
																</Box>
															</Box>
														</Grid>
														<Grid item xs={12} lg={3}>
															<Box
																style={{
																	display: 'flex',
																	justifyContent: 'space-between',
																	alignItems: 'center',
																}}>
																<h2>
																	₹
																	{Array.isArray(item?.fares)
																		? Number(Math.round(item?.fares[0]))
																		: Number(Math.round(item.fares))}
																</h2>
																<Button
																	onClick={() => {
																		item.id === tripid
																			? dispatch(setSelectedTripID(null))
																			: dispatch(setSelectedTripID(item.id));
																		let trip = {
																			tripid: item.id,
																		};
																		dispatch(fetchSeatLayoutDispatch(trip));
																	}}
																	style={{
																		background: '#EC5B24',
																		color: 'white',
																		width: '100%',
																		marginLeft: 20,
																	}}>
																	Select Seat
																</Button>
															</Box>
														</Grid>
													</Grid>
													{item.id === tripid && layoutloading ? (
														<h4 style={{ textAlign: 'center' }}>Loading...</h4>
													) : (
														''
													)}

													{layoutloading ? (
														''
													) : item.id === tripid ? (
														<Showseat seatLayout={seatLayout} item={item} />
													) : (
														''
													)}
												</Box>
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightResultSkeleton />;
								})
							)}
						</Grid>
					</Grid>
				</Box>
			</Container>
			<TopDrawer draw={draw} setDraw={setDraw} />
			<Footer />
		</div>
	);
};

export default SearchResultBus;
